import React, { ReactElement } from 'react';
import GroupByTag from './GroupByTag';
import SegmentBy from './SegmentBy';
import { FilterContainer } from './styles';

function TodaysActivity(props: {
    selectedReport: string;
    WorkGroupDropDown: ReactElement;
    RenderByWorkGroup: ReactElement;
    segmentBy: string;
    setSegmentBy: Function;
    isDrillDownActive: boolean;
    showAssigneeSegment: boolean;
    isTagFilterApplied: boolean;
    setIsTagFilterApplied: Function;
    showBy: string;
    setShowBy: Function;
}) {
    const {
        selectedReport,
        WorkGroupDropDown,
        segmentBy,
        setSegmentBy,
        isDrillDownActive,
        showAssigneeSegment,
        isTagFilterApplied,
        setIsTagFilterApplied,
        RenderByWorkGroup,
    } = props;
    return (
        <div>
            <FilterContainer className="filter-container">
                <GroupByTag
                    isTagFilterApplied={isTagFilterApplied}
                    setIsTagFilterApplied={setIsTagFilterApplied}
                    isDrillDownActive={isDrillDownActive}
                />
                <SegmentBy
                    selectedReport={selectedReport}
                    segmentBy={segmentBy}
                    setSegmentBy={setSegmentBy}
                    isDrillDownActive={isDrillDownActive}
                    showAssigneeSegment={showAssigneeSegment}
                    isTagFilterApplied={true}
                />
                <div className="--select-report-container">{WorkGroupDropDown}</div>
            </FilterContainer>

            <div className="mt-5">{RenderByWorkGroup}</div>
        </div>
    );
}

export default TodaysActivity;
